<script setup lang="ts">
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useCanvas from '@canvas-builder/composables/useCanvas'
import useReorderComponent from '@canvas-builder/composables/useReorderComponent'

const { canvasContent } = useCanvas()
const { isContentVisible } = useReorderComponent()

defineProps<{
  disabled?: boolean
}>()
</script>

<template>
  <CButton
    class="h-11 w-11"
    :disabled="!canvasContent.length || disabled"
    secondary
    size="large"
    strong
    :type="isContentVisible ? 'primary' : undefined"
  >
    <template #icon>
      <CIcon icon="layer-group" size="18" />
    </template>
  </CButton>
</template>
